import { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { subscribeToNewsletter } from '../utils/newsletter';
import PageBackdrop from '../components/PageBackdrop';
import { PAGE_BACKGROUNDS } from '../constants/brand';
import { NEWSLETTERS } from '../data/newsletters';
import usePageTitle from '../hooks/usePageTitle';

const Newsletter = () => {
  usePageTitle('Newsletter');
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const API = `${process.env.REACT_APP_BACKEND_URL}/api/v1`;

  const handleSubscribe = async (e) => {
    e.preventDefault();
    const ok = await subscribeToNewsletter(email, API);
    if (ok) {
      setSubscribed(true);
      setEmail('');
    }
  };

  return (
    <div className="min-h-screen bg-black film-grain relative overflow-hidden pt-32 pb-24">
      <PageBackdrop imageUrl={PAGE_BACKGROUNDS.newsletter} imageOpacity={0.5} overlay="light" />
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-16">
          <p className="chapter-label mb-6">THE DISPATCH</p>
          <h1 className="display-heading text-5xl md:text-7xl text-white mb-6">
            One craft essay.<br /><em>Every Sunday.</em>
          </h1>
          <p className="text-base text-zinc-400 leading-relaxed max-w-2xl">No promotions. No fluff. Just one deeply-researched piece from a working Mumbai filmmaker.</p>
        </div>

        <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3 mb-20 max-w-2xl">
          {subscribed ? (
            <p data-testid="newsletter-subscribed" className="text-[#7FB069] font-serif text-xl">Subscribed.</p>
          ) : (
            <>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
                className="flex-1 bg-[#0A0A0A] border border-white/10 text-white px-6 py-4 focus:outline-none focus:border-[#A80D1A] transition-colors"
                data-testid="newsletter-email-input"
              />
              <button type="submit" className="btn-cine-primary" data-testid="newsletter-subscribe-button">Subscribe</button>
            </>
          )}
        </form>

        <div className="space-y-px bg-white/5">
          {NEWSLETTERS.map((n, idx) => (
            <article key={n.newsletter_id} data-testid={`newsletter-item-${idx}`} className="bg-black/40 backdrop-blur-sm p-8 hover:bg-black/55 transition-colors cursor-pointer group border border-white/5">
              <div className="flex items-start justify-between gap-6">
                <div className="flex-1">
                  <p className="text-xs tracking-[0.2em] uppercase text-zinc-500 mb-3">{n.category}</p>
                  <h3 className="font-serif text-2xl md:text-3xl text-white mb-2 group-hover:text-[#C8102E] transition-colors">{n.title}</h3>
                  <p className="text-sm text-zinc-500">{new Date(n.published_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</p>
                </div>
                <ArrowRight className="w-5 h-5 text-zinc-600 group-hover:text-[#C8102E] group-hover:translate-x-1 transition-all" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
